export const remBase = 16

/**
 * A helper for convert pixels to rem.
 * @param {number} px - the number of pixels to convert.
 * @returns {string}
 */
export const pxToRem = (px) => `${px / remBase}rem`
